var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1447 0.143518L4.23578 6.88222C4.18933 6.92771 4.13413 6.96381 4.07334 6.98843C4.01255 7.01306 3.94738 7.02574 3.88156 7.02574C3.81574 7.02574 3.75056 7.01306 3.68978 6.98843C3.62899 6.96381 3.57379 6.92771 3.52734 6.88222L0.855571 4.27364C0.80912 4.22816 0.753918 4.19206 0.693132 4.16743C0.632346 4.14281 0.567172 4.13013 0.501351 4.13013C0.43553 4.13013 0.370357 4.14281 0.309571 4.16743C0.248785 4.19206 0.193583 4.22816 0.147132 4.27364C0.100498 4.31895 0.0634945 4.3728 0.0382458 4.43209C0.0129972 4.49139 0 4.55496 0 4.61916C0 4.68337 0.0129972 4.74694 0.0382458 4.80623C0.0634945 4.86553 0.100498 4.91937 0.147132 4.96468L2.8199 7.57131C3.10185 7.84582 3.48394 8 3.88231 8C4.28068 8 4.66277 7.84582 4.94472 7.57131L11.8531 0.834067C11.8997 0.788766 11.9366 0.73495 11.9618 0.675703C11.987 0.616455 12 0.552939 12 0.488792C12 0.424646 11.987 0.36113 11.9618 0.301882C11.9366 0.242634 11.8997 0.188819 11.8531 0.143518C11.8067 0.0980291 11.7515 0.0619349 11.6907 0.0373065C11.6299 0.012678 11.5647 0 11.4989 0C11.4331 0 11.3679 0.012678 11.3071 0.0373065C11.2463 0.0619349 11.1911 0.0980291 11.1447 0.143518Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick_icon.6803c018bbe0ced3252078a0f9c700dc.svg";
export { ForwardRef as ReactComponent };